import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import type { SWRConfiguration } from "swr";

import type { GetTrialGroupIdentityByIdResponse } from "src/api/Tmd.dtos";
import TrialGroupIdentityContext from "src/contexts/data/TrialGroupIdentityContext";
import useTrialGroupIdentityById from "src/hooks/data/load/useTrialGroupIdentityById";
import { parseRouteId } from "src/utilities/parseRouteId";

type Props = PropsWithChildren<{
    id?: number;
    configuration?: SWRConfiguration<
        GetTrialGroupIdentityByIdResponse,
        GetTrialGroupIdentityByIdResponse
    >;
}>;

/** Keeps identity available to every child route, including historical Data Entry. */
const TrialGroupIdentityProvider: FC<Props> = ({ id, configuration, children }) => {
    const state = useTrialGroupIdentityById(id, configuration);
    return (
        <TrialGroupIdentityContext.Provider value={state}>
            {children}
        </TrialGroupIdentityContext.Provider>
    );
};

export const RouteTrialGroupIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const id = parseRouteId(useParams<{ trialGroupId?: string }>().trialGroupId);
    return <TrialGroupIdentityProvider id={id}>{children}</TrialGroupIdentityProvider>;
};

export default TrialGroupIdentityProvider;
